//
//
//
//
//

export default {
  name: "transition-navigate",
};
